import styled from 'styled-components';
import { isPortrait } from '../../utils/size';

export const Group = styled.div`
    display: block;
    margin-top: 12px;

    > div {
        position: relative;
    }

    button {
        &.submitButton {
            ${props => (props.isSubmitting ? `text-indent: -99999px;` : '')};

            @media (max-width: 30em) {
                width: calc(50% - 0.5em);
                margin-left: 0.5em;
            }
        }

        &:focus {
            outline: none;
        }

        + div {
            position: absolute;
            display: none;
            top: 7px;
            right: ${() => (isPortrait() ? `12.5%` : `17%`)};
            margin-right: 16px;
            width: 32px !important;
            height: 32px !important;
            ${props => (props.isSubmitting ? `display: block` : '')};
        }
    }
`;

export const LegalInfoWrapper = styled.div`
    flex: 1;

    div {
        margin-right: 0;
        padding: 0;

        &:last-child {
            margin-left: 0;
            max-width: 100%;
            margin-right: 0;
        }
    }
`;

export const FormGroupWrapper = styled.div`
    margin: 0;
    margin-right: 0 !important;

    div {
        padding-bottom: 0;
        ${() => !isPortrait() && `padding: 0`};
    }

    @media (max-width: 30em) {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0;

        > div {
            flex: 1;
            display: flex;
            width: 100%;
            flex-direction: column;
            margin: 0 0.5em;
        }
    }
`;

export const Label = styled.p`
    font-family: Averta;
    font-size: 0.5em;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
`;
